import {
  BulkAddToShortlistsAction,
  BulkOfferCustomizedAction,
  BulkOfferSentAction,
  UserAction
} from '../../types/user-actions';

export const isBulkAddToShortlistsAction = (
  action?: UserAction
): action is BulkAddToShortlistsAction => (
  action !== undefined
  && action.eventCategory === 'bulk-offer'
  && action.eventAction === 'bulk-add-to-shortlists'
);

export const isBulkOfferCustomizedAction = (
  action?: UserAction
): action is BulkOfferCustomizedAction => (
  action !== undefined
  && action.eventCategory === 'bulk-offer'
  && action.eventAction === 'bulk-offer-customized'
);

export const isBulkOfferSentAction = (
  action?: UserAction
): action is BulkOfferSentAction => (
  action !== undefined
  && action.eventCategory === 'bulk-offer'
  && action.eventAction === 'bulk-offer-sent'
);
